import { ViewChild, Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { NewRiderComponent } from '../../home/modules/riders/components/new-rider/new-rider.component';
import { Rider, RidersFilters } from '../../../commons/models/riders';
import { ActivatedRoute } from '@angular/router';
import { replaceInArray, removeFromArray } from '../../../helpers/array.utils';
import { DialogComponent } from '../components/dialog/dialog.component';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { Observable } from "rxjs";

@Component({
  selector: 'app-riders-list',
  templateUrl: './riders-list.component.html',
  styleUrls: ['./riders-list.component.scss']
})
export class RidersListComponent {
   @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    @Input() riders: Rider[];
    @Input() selectedRiders: Rider[];
    @Input() defaultFilters: RidersFilters;

    @Input() total: Observable<number>;
    @Input() displayedColumns: string[] = ['name', 'surname', 'phone', 'email', 'actions'];

    @Input()
    canAdd: boolean;
    @Input()
    canEdit: boolean;
    @Input()
    canSelect: boolean;

    pageSizeOptions = PAGE_SIZE_OPTIONS;

    @Output()
    onLoad: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
    @Output()
    onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
    @Output()
    onFilterChange: EventEmitter<RidersFilters> = new EventEmitter<RidersFilters>();

    @Output()
    onSelectRider: EventEmitter<Rider> = new EventEmitter<Rider>();
    @Output()
    onAddRider: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onEditRider: EventEmitter<Rider> = new EventEmitter<Rider>();
    @Output()
    onShowRider: EventEmitter<Rider> = new EventEmitter<Rider>();
    @Output()
    onAddSelectedRider: EventEmitter<Rider> = new EventEmitter<Rider>();
    @Output()
    onRemoveSelectedRider: EventEmitter<Rider> = new EventEmitter<Rider>();

    get selectedItems(): boolean {
      return this.selectedRiders.length > 0;
    }
  
    ngAfterViewInit() {
      this.sort.sortChange.subscribe((sort) => {
        this.onSortChange.emit(sort);
      });
      this.paginator.page.subscribe((pageEvent) => {
        this.onPageChange.emit(pageEvent);
      });
    }

    isSelected(rider: Rider): boolean {
      return this.selectedRiders.map(obj => obj.id).includes(rider.id)
    }
  
    addRider() {
      this.onAddRider.emit();
    }
  
    addSelectedRider(rider: Rider) {
      if(this.isSelectable(rider)) {
        this.onAddSelectedRider.emit(rider);
      }
    }
  
    isSelectable(rider: Rider): boolean {
      return !rider.id
    }
  
    removeSelectedRider(rider: Rider) {
      this.onRemoveSelectedRider.emit(rider)
    }
  
    toggleSelectedRider(rider: Rider) {
      if (this.isSelected(rider)) {
        this.removeSelectedRider(rider);
      } else {
        this.addSelectedRider(rider);
      }
    }
  
    editRider(rider: Rider) {
      this.onEditRider.emit(rider);
    }
  
    selectRider(rider: Rider) {
      this.onSelectRider.emit(rider);
    }
  
    onFilter(filters: RidersFilters) {
      this.paginator.firstPage();
      this.onFilterChange.emit(filters);
      console.log("firstpage:", this.paginator.firstPage());
    }
  
    showRider(activityList: Rider) {
      this.onShowRider.emit(activityList);
    }

    isAllSelected() {
      const numSelected = this.selectedRiders.length;
      const numRows = this.riders.filter(bl => this.isSelectable(bl)).length;
      return numSelected === numRows;
    }
  

}
